import { DOCUMENT, InjectionToken, inject } from '@angular/core';

/** Objekty prohlížeče přes DI (lze je v testech nahradit). Nahrazují tokeny `WA_*` z `@ng-web-apis/common`. */
export const WINDOW = new InjectionToken<Window>('WINDOW', {
  factory: () => {
    const window = inject(DOCUMENT).defaultView;
    if (!window) throw new Error('Window není k dispozici.');
    return window;
  },
});

export const LOCATION = new InjectionToken<Location>('LOCATION', { factory: () => inject(WINDOW).location });

export const LOCAL_STORAGE = new InjectionToken<Storage>('LOCAL_STORAGE', {
  factory: () => inject(WINDOW).localStorage,
});

export const SESSION_STORAGE = new InjectionToken<Storage>('SESSION_STORAGE', {
  factory: () => inject(WINDOW).sessionStorage,
});
